// A mismatch is an unavailable check, never evidence of a missing bank account.
export const createExternalAccountsLoader = (load, { now = Date.now, ttl = 60000 } = {}) => {
  let current = null;
  return (token) => {
    if (current?.token === token && (current.pending || current.expiresAt > now())) return current.promise;
    const entry = { token, pending: true, expiresAt: 0 };
    current = entry;
    entry.promise = Promise.resolve().then(() => load(token)).then((result) => {
      if (result?.code === 'stripe_account_mode_mismatch') entry.expiresAt = now() + ttl;
      return result;
    }).finally(() => {
      entry.pending = false;
      if (current === entry && !entry.expiresAt) current = null;
    });
    return entry.promise;
  };
};
